import { render } from "./Cuenta.vue?vue&type=template&id=be894d6c&scoped=true"
import script from "./Cuenta.vue?vue&type=script&lang=js"
export * from "./Cuenta.vue?vue&type=script&lang=js"

import "./Cuenta.vue?vue&type=style&index=0&id=be894d6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be894d6c"]])

export default __exports__